import React from "react";
import {BaseThatsMeIconProps} from "../../interfaces/baseThatsMeIconProps.interface";

export default (props: BaseThatsMeIconProps) => {
    const {size = 24, ...rest} = props;
    return <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <rect x="0.5" y="4.5" width="27" height="21" fill="#83FFAD" stroke="black"/>
        <path d="M13.3312 21V11.016H10.3232V9.79999H17.6832V11.016H14.6752V21H13.3312Z" fill="black"/>
        <rect x="0.5" y="0.5" width="10" height="4" fill="#83FFAD" stroke="black"/>
    </svg>
}
